import { _ as __assign } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { M as MessageInputWrapperView } from '../../chunks/bundle-BoAtUmX0.js';
export { V as VoiceMessageInputWrapper } from '../../chunks/bundle-BoAtUmX0.js';
import { u as useGroupChannel } from '../../chunks/bundle-CGu41Cov.js';
import '../../chunks/bundle-DxuHs_7y.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-DGylLBIn.js';
import './SuggestedMentionList.js';
import '../../chunks/bundle-MhQ-_j2c.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-B667kaG5.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../chunks/bundle-QUexVbet.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-x5dO2c1K.js';
import '../../VoiceRecorder/context.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import 'react-dom';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-Br7l2qHZ.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DMyARZj7.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-y-5JpD-m.js';
import 'dompurify';
import '../../chunks/bundle-DgkSQIK-.js';
import '../../chunks/bundle-C6zIjPZB.js';
import '../../chunks/bundle-rD5ecRD2.js';
import '../../chunks/bundle-DvAn8oVD.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-DqU2mzDL.js';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-Dwuqku8L.js';
import '../../chunks/bundle-CyNQH9Yl.js';
import '../../chunks/bundle-B2eoNpzc.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-CiiVQ3uH.js';

var MessageInputWrapper = function (props) {
    var _a = useGroupChannel(), state = _a.state, actions = _a.actions;
    return React__default.createElement(MessageInputWrapperView, __assign({}, props, state, actions));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInputWrapper.js.map
